

import { Vue, Component, Prop, Ref, Inject } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { FormDef, FormOptions, SelectboxDef, SelectboxOptions } from '../../type'
import FieldMixins from './FieldMixins'

let index = 1

@Component({
  components: {
    'form-control': () => import('../index.vue')
  }
})
export default class TableControl extends mixins(FieldMixins) {
  @Inject() exists!: (row: any, rowForm?: Record<string, any>) => boolean

  get options () {
    return Object.assign(new SelectboxOptions(), this.def?.options)
  }

  genKey () {
    return Date.now() + '_' + index++
  }

  def!: SelectboxDef
}
